module.exports = __webpack_public_path__ + "img/amari-and-the-night-brothers.2b09c23d.png";